import { z } from 'zod';
import { uuidSchema } from './common.js';

/**
 * Virtual comp re-baseline review DTOs (SIL-1827). OPS-ADMIN-ONLY surface:
 * items carry virtual and proposed prices. The pending-summary deliberately
 * returns only {count, oldestPendingAgeSeconds} (no ids, names or prices).
 */

export const virtualCompReviewIdParamSchema = z.object({ id: uuidSchema });

export const listVirtualCompReviewsQuerySchema = z.object({
  status: z.enum(['open', 'accepted', 'rejected', 'superseded']).default('open'),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});

/** Reject reason: trimmed 1..1000, no control characters (rendered as a React text node only). */
export const rejectVirtualCompReviewBodySchema = z
  .object({
    reason: z
      .string()
      .trim()
      .min(1)
      .max(1000)
      // eslint-disable-next-line no-control-regex
      .regex(/^[^\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]*$/, 'reason must not contain control characters'),
  })
  .strict();
export type RejectVirtualCompReviewBody = z.infer<typeof rejectVirtualCompReviewBodySchema>;

export const virtualCompReviewSchema = z.object({
  id: z.string(),
  assetId: z.string(),
  skuId: z.string(),
  skuName: z.string().nullable(),
  status: z.enum(['open', 'accepted', 'rejected', 'superseded']),
  virtualPriceUsd: z.number(),
  proposedBaselineUsd: z.number().nullable(),
  proposedSampleSize: z.number().nullable(),
  proposedConditionBand: z.string().nullable(),
  deviationRatio: z.number().nullable(),
  reason: z.string(),
  createdAt: z.string(),
  resolvedAt: z.string().nullable(),
  resolvedByActorSub: z.string().nullable(),
  note: z.string().nullable(),
  resolutionSnapshotId: z.string().nullable(),
});
export type VirtualCompReview = z.infer<typeof virtualCompReviewSchema>;

export const virtualCompReviewPendingSummarySchema = z.object({
  count: z.number().int().nonnegative(),
  oldestPendingAgeSeconds: z.number().nonnegative().nullable(),
});
export type VirtualCompReviewPendingSummary = z.infer<typeof virtualCompReviewPendingSummarySchema>;
